const updates = [
  { time: '10分钟前', title: '新一批明星税务问题被曝光，涉及多位一线艺人', tag: '突发' },
  { time: '28分钟前', title: '某热播剧男二号被曝片场耍大牌，剧组内部矛盾浮出水面', tag: '独家' },
  { time: '1小时前', title: '知名导演新片选角内幕曝光，潜规则话题再引热议', tag: '深度' },
  { time: '2小时前', title: '综艺节目常驻嘉宾被替换，背后原因引发粉丝猜测', tag: '热议' },
  { time: '3小时前', title: '短视频平台头部创作者集体解约，行业大地震', tag: '追踪' },
  { time: '5小时前', title: '某影后婚姻状况再度引发关注，知情人士透露更多细节', tag: '独家' },
  { time: '7小时前', title: '娱乐圈新一轮整风行动启动，多家经纪公司被约谈', tag: '快讯' },
];

const tagStyles: Record<string, string> = {
  '突发': 'bg-primary-500 text-background-50',
  '独家': 'bg-accent-500 text-background-50',
  '深度': 'bg-secondary-500 text-background-50',
  '热议': 'bg-primary-100 text-primary-700',
  '追踪': 'bg-accent-100 text-accent-700',
  '快讯': 'bg-secondary-100 text-secondary-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-bold mb-4">
            <i className="ri-timer-flash-line"></i>
            最新动态
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-3">
            实时吃瓜快讯
          </h2>
          <p className="text-foreground-500 text-sm">分秒必争，最新八卦动态一秒不落</p>
        </div>

        <div className="relative pl-8 border-l-2 border-background-300 space-y-6 ml-2">
          {updates.map((item, i) => (
            <div key={i} className="relative group">
              <div className="absolute -left-[33px] top-1.5 w-3 h-3 rounded-full bg-accent-500 border-2 border-background-100 group-hover:scale-125 transition-transform"></div>
              <div className="bg-background-50 rounded-xl p-4 hover:shadow-md transition-all duration-200">
                <div className="flex items-center gap-2 mb-1.5">
                  <span className="text-xs text-foreground-400">{item.time}</span>
                  <span className={`text-xs px-2 py-0.5 rounded-full font-bold ${tagStyles[item.tag]}`}>{item.tag}</span>
                </div>
                <h3 className="text-sm font-bold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}